//
import { Component } from "react"
import PropTypes from "prop-types"

import { genericFilterGroup, createPACTransactionsFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import { ElectionTypeFilter, ElectionCycleFilter } from "shared/search/containers/Filter/ElectionFilters"

export class ElectionTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [ElectionTypeFilter],
        uniqueFilterGroupId: "electionTypeFilterGroup",
        displayLabel: "Election Type",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class ElectionCycleFilterGroup extends Component {
    static defaultProps = {
        filters: [ElectionCycleFilter],
        uniqueFilterGroupId: "electionCycleFilterGroup",
        displayLabel: "Election Cycle",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const ElectionAmountFilterGroup = createPACTransactionsFilterGroup({
    displayLabel: "PAC Activity",
    quorumDataType: DjangIO.app.models.QuorumDataType.election,
    uniqueFilterGroupId: "electionAmountFilterGroup",
})
